// @flow
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { Separator } from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import Axis from './CharacteristicSliderAxis';
import OptionSliderContent from './OptionSliderContent';
import OptionZoneValidity from './OptionZoneValidity';
import Price from './CharacteristicSliderPrice';
import Label from './CharacteristicSliderLabel';
import theme from '../../../theme-config';
import config from '../../../config';
import { OptionRow } from '../';
import { getSecondaryCharacteristicsForOptions } from '../../../lib/optionsFormatter';
import { isEmpty } from 'lodash';

const OptionSlider = (props: Props) => {
  return (
    <View testID={props.testID} style={{width: '100%'}}>
      <OptionSliderContent {...props} sliderTestID={props.sliderTestID} currency={config.currency} outerMargin={20} sliderMargin={15} sliderFlex={3} badge={props.badge} labelOverride={props.labelOverride} disabled={props.disabled} />
      {displayOptionRow({ ...props.optionRowInfos, name: props.name })}
      {props.withZoneValidity && <OptionZoneValidity name={props.name} />}
      {getSecondaryCharacteristicsForOptionType(props.selectedOptions, props.name).map((characteristic, index) => (
       <OptionZoneValidity
          key={`${characteristic.name} ${index}`}
          name={characteristic.name}
          unit={characteristic.unit}
          value={characteristic.value}
        />
      ))}
      {props.withSeparator && <Separator crossAxisMargin={15} />}
    </View>
  );
};

const getSecondaryCharacteristicsForOptionType = (selectedOptions, type) => {
  const options = selectedOptions.filter(option => option.type === type);

  return getSecondaryCharacteristicsForOptions(options);
};

const displayOptionRow = optionRowInfos => {
  const { availableTopUps, travelZone, getSelectedVoiceTopUp, selectedTopUps } = optionRowInfos;

  if (
    !travelZone ||
    !(optionRowInfos.name.includes('ROA') && optionRowInfos.name.includes('VOICE')) ||
    !getSelectedVoiceTopUp
  ) {
    return null;
  }

  const selectedVoiceOption = getSelectedVoiceTopUp(selectedTopUps);

  if (!isEmpty(availableTopUps)) {
    const characteristics = selectedVoiceOption?.characteristics;

    let numberOfSmsIncluded = 0;

    if (characteristics) {
      const smsCharacteristic = characteristics.find(characteristic => characteristic.name.includes('SMS'));
      numberOfSmsIncluded = smsCharacteristic?.value || 0;
    }

    const title = I18n.t('catalog.SMS_CREDIT_DETAIL', { value: numberOfSmsIncluded });
    return (
      <View style={styles.optionRow}>
        <OptionRow value={numberOfSmsIncluded} title={title} />
      </View>
    );
  }
};

const styles = StyleSheet.create({
  optionRow: {
    marginBottom: 33,
    marginLeft: 36,
  },
  separator: {
    backgroundColor: theme.gray.normalLight,
    height: 1,
    marginVertical: 15,
    opacity: 0.25,
  },
});

type State = {
  secondaryCharacteristicsForOptionType: (type: string) => Object[],
};

type Props = {
  testID?: string,
  name: string,
  onPressHelpIcon: ?Function,
  options: Object[],
  optionRowInfos: {
    availableTopUps?: { [string]: Object[] },
    getSelectedVoiceTopUp?: Function,
    selectedTopUps: Object[],
    travelZone: ?string,
  },
  priceKey: string,
  selectedOptions: Object[],
  withSeparator: ?boolean,
  withZoneValidity?: boolean,
  badge?: React.Node,
  labelOverride?: string,
} & State;

OptionSlider.Axis = Axis;
OptionSlider.Content = OptionSliderContent;
OptionSlider.Price = Price;
OptionSlider.Label = Label;

export default OptionSlider;
